export const HEADER_BACKGROUND_BREAKPOINTS = {
    tablet: 480,
    desktop: 980,
    twok: 1350,
};
